
import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { RodeoService } from '../../../../../services/rodeo.service';
import { Rodeo } from '../../../../../model/rodeo';
import { AlertMessager } from '../../../../../lib/alertMessager';
import { StockGroup } from '../../../../../model/stock-group';
import { StockService } from '../../../../../services/stock.service';
import { StockContractor } from '../../../../../model/stock-contractor';
import { SearchBoxComponentV2 } from '../../settings/search-box.component.v2';
import { Livestock } from '../../../../../model/livestock';

@Component({
    selector: 'stock-group-prompt',
    templateUrl: 'stock-group-prompt.html'
})
export class StockGroupPromptPage {
    @ViewChild(SearchBoxComponentV2) searchBox;
    rodeo: Rodeo;
    stockGroup: StockGroup;
    stockContractorName: string = "";
    searchBoxVisible: boolean;
    livestock: Livestock[];

    bulkFile: any;

    loadingData: boolean;

    constructor(navParams: NavParams, private viewController: ViewController, private alert: AlertMessager, private stockService: StockService,
        private loadingController: LoadingController, private loadingControl: LoadingController, private toast: ToastController) {
        this.rodeo = navParams.get('rodeo');
        this.stockGroup = navParams.get('stockGroup');

        if (!this.stockGroup)
            this.stockGroup = new StockGroup();
    }

    showSearchBox() {
        this.searchBoxVisible = true;
        setTimeout(() => {
            this.searchBox.onSearchChange(null, this.stockContractorName);
        })
    }

    updateStockContractor(stockContractor: StockContractor) {
        this.stockGroup.stockContractor = stockContractor;
        this.stockGroup.stockContractorId = stockContractor.id;
        this.stockContractorName = stockContractor.name;
        this.searchBoxVisible = false;
    }

    public searchStockContractors(searchValue: string) {
        this.loadingData = true;

        this.stockService.searchStockContractors(searchValue)
        .then(data => {
            this.loadingData = false;

            return data;
        })
        .catch(error => {
            this.alert.showError('Error', 'Unable to retrieve search results: ' + error);
            this.loadingData = false;

            return [];
        });
    }

    bulkUploadFileChanged($event): void {
        this.bulkFile = $event.target.files[0];
        this.livestock = [];

        var reader = new FileReader();
        
        reader.onload = (e) => {
            var text = (e.target as any).result;
            var delimiter = ",";

            const rows = (text as string).split("\n");

            rows.forEach((row) => {
                var stockComponents = row.split(delimiter);
                this.livestock.push(new Livestock(stockComponents[0], stockComponents.length > 1 ? stockComponents[1] : null));
            });
        }
        
        reader.readAsText(this.bulkFile);
    }

    uploadAgreementFile() {
        let loader = this.loadingController.create({
            content: 'Processing file...',
        });

        loader.present();
    }

    create() {
        let loading = this.loadingControl.create({
            content: 'Creating Stock Group...',
        });

        this.stockGroup.livestock = this.livestock;

        loading.present();
        this.stockService.addStockGroup(this.stockGroup, this.rodeo.id)
            .then(data => {
                loading.dismiss();
                this.rodeo.stockGroups.push(data as StockGroup);
                this.toast.create({
                    message: 'Stock Group ' + this.stockGroup.name + ' added!',
                    duration: 3000,
                    position: 'middle',
                }).present();

                this.viewController.dismiss();
            }, error => {
                loading.dismiss();
                this.alert.showError("Stock Group Add Error", error);
            });
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/draw/stock/stock-group-prompt.ts